import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'

const incomeRecordRouter: RouteConfig = {
  path: '/pays/payroll/incomeRecord',
  name: 'incomeRecord',
  component: Layout,
  redirect: '/pays/payroll/incomeRecord/list',

  meta: {
    title: '服务收入记录表'
  },
  children:[
    {
      path:'list',
      name:'incomeRecordList',
      component:() => import(/* webpackChunkName: "incomeRecord" */'@/views/pays/incomeRecordList.vue'),
      meta:{
        title:'服务收入记录表',
      }
    }
  ]
}

export default incomeRecordRouter
